// extracted by mini-css-extract-plugin
module.exports = {"home":"page_home__e4rxy","home__cn":"page_home__cn__4XQTo","home__husky":"page_home__husky__p7WuI"};